class ProductBundle extends HTMLElement {
  constructor() {
    super();
    this.cartNotification = document.querySelector('cart-notification');
    this.originalPriceHtml = this.querySelector('[data-smartrr-compare-price]')
    this.regularPriceHtml = this.querySelector('[data-smartrr-subscribe-price]')
    this.cart = document.querySelector('cart-drawer');

    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      if (this.dataset.section === event.data.sectionId && !!event.data.sectionId) {
        this.updatePriceHtml(event.data.variant)
      }
    });
  }

  async upgradeBundle (submitButton, props) {
    submitButton.classList.add('loading')
    submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden')

    const { variantId, quantity = 1, id } = props
    const { items } = await fetch('/cart.js').then(res => res.json())
    const mainItemInCart = items.find(item => +item.variant_id === +variantId)

    if (mainItemInCart) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {
            [mainItemInCart.id]: (mainItemInCart.quantity - parseInt(quantity))
          }
        })
      })
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', id)
    formData.append('sections', [...this.cart.getSectionsToRender()].map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');

        if (submitButton.closest('.js-bundle-popup')) {
          submitButton.closest('.js-bundle-popup').removeAttribute('open')
        }
      });
  }

  updatePriceHtml (variant) {
    if (this.originalPriceHtml) {
      this.originalPriceHtml.innerHTML = variant.compare_at_price ? formatMoney(variant.compare_at_price / 100) : ''
    }

    if (this.regularPriceHtml) this.regularPriceHtml.innerHTML = formatMoney(variant.price / 100)
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}
class ProductBundleInline extends ProductBundle {
  constructor() {
    super();
    this.variantId = this.dataset.mainId
    this.bundleVariantId = this.dataset.bundleId
    this.upgradeButtons = this.querySelectorAll('.js-bundle-upgrade')
  }

  connectedCallback() {
    this.setupEventListener()
  }

  setupEventListener () {
    Array.from(this.upgradeButtons).map(upgradeButton => {
      upgradeButton.addEventListener('click', (e) => {
        e.preventDefault();

        this.upgrade(upgradeButton)
      })
    })
  }

  upgrade (submitButton) {
    this.upgradeBundle(submitButton, {
      variantId: this.variantId,
      id: this.bundleVariantId
    })
  }
}

customElements.define('product-bundle-inline', ProductBundleInline);
